var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title":_vm.area.name,"back-to":_vm.backTo || '/outdoor',"links":_vm.headerLinks}})
}
var staticRenderFns = []

export { render, staticRenderFns }